import { xposParamsMap, } from '@didi/webx-js-core';
import { utils } from '../utils';
import { getOmega } from '../omega';
import { getNineChapterCommonParams, getNineChapterGotoParams, getNineChapterSameProductGotoParams, } from '../statistic';
const getGoToParams = (option = {}) => {
    if (!utils.isObj(option))
        return {};
    const { sameProduct, xspmInfo, resourceInfo } = option;
    const collection = sameProduct
        ? getNineChapterSameProductGotoParams()
        : getNineChapterGotoParams();
    if (utils.isObj(xspmInfo) && Object.keys(xspmInfo).length > 0 && getOmega()) {
        const _xspmInfo = utils.cloneDeep(xspmInfo);
        if (!_xspmInfo['a']) {
            const commonParams = getNineChapterCommonParams();
            _xspmInfo['a'] = commonParams['prod_key'];
        }
        collection['xspm_from'] = getOmega().formatSpmPath
            ? getOmega().formatSpmPath(xspmInfo)
            : '';
    }
    else {
        delete collection['xspm_from'];
    }
    if (utils.isObj(resourceInfo) && Object.keys(resourceInfo).length > 0) {
        let _resourceInfo = utils.cloneDeep(resourceInfo);
        /* 检查必填项 */
        const pass = getArrEqual(['resname', 'element_name', 'xspm'], Object.keys(resourceInfo));
        if (pass) {
            /* 默认绑定当前prod_key */
            if (!resourceInfo['prod_key']) {
                const commonParams = getNineChapterCommonParams();
                resourceInfo['prod_key'] = commonParams['prod_key'];
            }
            /* xpos参数映射 */
            _resourceInfo = Object.entries(_resourceInfo).reduce((res, [key, value]) => {
                if (xposParamsMap[key]) {
                    // 需要映射 进行key转换
                    res[xposParamsMap[key]] = value;
                }
                else {
                    res[key] = value;
                }
                return res;
            }, {});
            collection['xpos_from'] = encodeURIComponent(JSON.stringify(_resourceInfo));
            /* 有xpos 没有xpsm的场景下 默认使用xpos.xspm填充xspm */
            if (!collection['xspm_from'] && _resourceInfo['xp']) {
                collection['xspm_from'] = getOmega().formatSpmPath
                    ? getOmega().formatSpmPath({
                        a: resourceInfo['pk'],
                        c: resourceInfo['xp'],
                        d: resourceInfo['idx'],
                    })
                    : '';
            }
        }
    }
    else {
        delete collection['xpos_from'];
    }
    return collection;
};
const getArrEqual = (arr1, arr2) => {
    return arr1.reduce((list, item1) => {
        if (arr2.find((item2) => item1 === item2))
            list.push(item1);
        return list;
    }, []);
};
export { getGoToParams };
